import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip as TooltipRC, Legend } from 'recharts';

import type { ILineChartData } from 'v2/interfaces/dashboard';

import type { TickItem } from 'recharts/types/util/types';

interface IProps {
  data: ILineChartData[];
  totalGains: number;
}

interface ILabelProps {
  payload?: TickItem;
  y?: number;
  x?: number;
}

interface ILegendProps {
  payload?: any[];
}

const legendStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    listStyle: 'none',
    margin: `${theme.spacing(2)}px -16px ${theme.spacing(2)}px 0`,
  },
  legendItem: {
    display: 'flex',
    marginRight: 15,
    fontSize: 13,
    fontWeight: 600,
  },
  legendIcon: {
    display: 'block',
    width: 3,
    height: 18,
    borderRadius: 2,
    transform: 'rotate(45deg)',
    marginRight: 12,
  },
}));

const LegendContent = ({ payload }: ILegendProps) => {
  const classes = legendStyles();

  return (
    <ul className={classes.root}>
      {payload.map((entry) => (
        <li className={classes.legendItem} key={entry.value}>
          <span className={classes.legendIcon} style={{ backgroundColor: entry.color }} />
          {entry.value}
        </li>
      ))}
    </ul>
  );
};

const DatePick = ({ payload, y, x, ...rest }: ILabelProps) => {
  return (
    <>
      <text y={y + 15} x={x - 15} {...rest} color='#B0BEC5'>
        {payload.value}
      </text>
    </>
  );
};

const Chart = ({ data, totalGains }: IProps) => {
  const isNegativeGains = totalGains < 0;

  return (
    <ResponsiveContainer width='100%' height={280}>
      <LineChart
        data={data}
        margin={{
          left: -7,
          right: 16,
          bottom: 11,
        }}
      >
        <Legend offset={50} verticalAlign='top' content={<LegendContent />} />
        <Line dataKey='producer' name='Produtor' stroke='#FF5C00' fill='#FF5C00' strokeWidth={2} dot />
        <Line dataKey='coproducer' name='Co-Produtor' stroke='#FFBE00' fill='#FFBE00' strokeWidth={2} dot />
        <Line dataKey='affiliate' name='Afiliado' stroke='#14286E' fill='#14286E' strokeWidth={2} dot />
        <CartesianGrid strokeDasharray='0' />
        <XAxis dataKey='date' fontSize={12} interval={data.length < 10 && 0} tick={<DatePick />} />
        <YAxis
          type='number'
          allowDecimals={false}
          interval='preserveStartEnd'
          fontSize={13}
          domain={[0, isNegativeGains ? Math.abs(totalGains) : 'auto']}
        />
        <TooltipRC />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default Chart;
